import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { createNumberAriaLabel } from 'helpers/accessibility/ariaLabelHelpers';
import { replaceAll } from 'helpers/replaceAll';
import useTranslation from 'next-translate/useTranslation';
import { PhoneIcon } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';

type ContactProps = {
    desktopOnly?: boolean;
    textColor?: string;
};

const Contact: FC<ContactProps> = ({ desktopOnly, textColor }) => {
    const { t } = useTranslation();
    const phone = t('Header phone number');
    const { diallingCode } = useDomainConfig();

    return (
        <div className={twJoin('pr-5 vl:pr-0', desktopOnly && 'hidden vl:block', textColor ?? 'text-primary')}>
            <div className="flex h-5 items-center">
                <div className="h-full w-6">
                    <PhoneIcon className="text-currentColor" />
                </div>
                <a
                    aria-label={createNumberAriaLabel(phone)}
                    className="font-bold text-inherit no-underline hover:text-inherit hover:no-underline"
                    href={`tel:${diallingCode}${replaceAll(phone, ' ', '')}`}
                    tabIndex={0}
                >
                    {phone}
                </a>
            </div>
            <div className="h-4 pl-6 text-tiny notVl:hidden">{t('Header opening hours')}</div>
        </div>
    );
};

export default Contact;
